import classNames from 'classnames';
import { useIsMobile } from '~/components/Breakpoint/Breakpoint.hook';
import { PlaceholderCard } from '~/components/Card/Placeholder';
import { PlaceholderGrid } from '~/components/Grid/Placeholder/PlaceholderGrid';
import {
  MarketplaceNftCard,
  MarketplaceNftCategoryType,
  useMarketplaceNfts,
} from '~/components/Nft';
import styles from './MarketplaceExplorerCardList.module.scss';

export type MarketplaceExplorerCardListProps = {
  categoryType?: MarketplaceNftCategoryType;
  className?: string;
};
export const MarketplaceExplorerCardList = ({
  categoryType,
  className,
}: MarketplaceExplorerCardListProps) => {
  const isMobile = useIsMobile();
  const { data: items = [], isFetching } = useMarketplaceNfts(
    { categoryType, size: isMobile ? 6 : 8 },
    {
      initialData: undefined,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  return (
    <PlaceholderGrid
      placeholder={<PlaceholderCard type="face" className={styles.placeholder} />}
      className={classNames(styles.root, { [styles.loading]: isFetching }, className)}>
      {items.map((item) => (
        <li key={item.id}>
          <a
            className="display-block"
            href={`${import.meta.env.VITE_CITIZEN_STORE_URL}/nfts/${item.id}`}
            data-event="click"
            data-event-target="item_c2c"
            data-event-brand_id="1"
            data-event-currency_type={item.currency}
            data-event-sale_price={item.price}
            data-event-is_bundle="false">
            <MarketplaceNftCard className={styles.card} {...item} contentsType="IMAGE" />
          </a>
        </li>
      ))}
    </PlaceholderGrid>
  );
};
